import React from 'react'

const Purchases = () => {
  return (
    <div className='FadeIn'>Purchases</div>
  )
}

export default Purchases